import { RpcClient } from '../rpc-socket/rpcClient';

export namespace DialogsApi {
  export type TCreateChoiceListItem = {
    name: string;
    data: number;
  };
  export type TCreateChoiceList = {
    selectionList: {
      caption: string;
      button: string;
      list: Array<TCreateChoiceListItem>;
    };
  };

  export type TSetChoiceResult = {
    selectionList: number;
  };

  export const setChoiceResult = (request: TSetChoiceResult) => {
    return RpcClient.call('setChoiceResult', request) as Promise<boolean>;
  };

  export type TLock = {
    blockUI: any;
    progress: number; // Необязательный параметр
    caption: string; // Необязательный параметр
    canAbort: boolean; //Доступность отмены прогресса
    progressId?: number; // В разработке; Обязательный параметр
  };
}
